import styled from "styled-components";
import Colors from "../../constants/Colors";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 620px) {
    flex-direction: column;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 620px) {
    flex-direction: column;
  }
`;  

export const ExamsContainers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-bottom: 30px;
`;

export const ExamCardInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-top: 10px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);
`;

export const ExamsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 16px;
  margin-bottom: -6px;
`;

export const ExamCardContainer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  padding: 14px 20px;
  gap: 16px;
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: #0a5190;
    box-shadow: 0 6px 14px rgba(10, 81, 144, 0.08);
  }
`;

export const ExamCardNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  @media screen and (max-width: 620px) {
    flex-direction: column;
  }
`;

export const ExamCardDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  @media screen and (max-width: 620px) {
    flex-direction: column-reverse;
  }
`;
